import { formatValue } from "../utils/helpers";
import { DisaggregatedMetric, MetricMetadata } from "../services/types";

interface MetricCardProps {
    metric: DisaggregatedMetric;
    width: string;
    metadata: MetricMetadata[] | null;
    svg?: string;
    showMetadataIcon?: boolean;
};

const  MetricCard = ({ metric, metadata, svg }: MetricCardProps) => {
    // Destructure metric properties
    const { id, name, versions } = metric;
    const { value, unit, unit_descriptor, percent_calc } = versions[0];

    const val = unit === "ratio" ? `${percent_calc?.n}/${percent_calc?.d}` : value; 
    
    // Find metadata for the current metric
    const metricMetadata = metadata?.find(m => m.id === id);
    const definition = metricMetadata?.definition;

    return (
        <div className="mx-2 my-2">
            <div className="flex flex-col items-start w-full">
                <div className="flex items-center justify-start">
                    { svg && <img src={svg} alt={`${name} icon`} className="w-[60px] h-[60px] text-blue-500" /> }
                    
                    <h2 className={`text-port-blue text-3xl font-barlow-condensed font-bold ${svg ? 'ml-2' : 'ml-0'}`}>{formatValue(val, unit, id)}</h2>
                </div>
                <div className="flex my-1 max-w-44">
                    <p className={`text-port-text text-xs font-bold`}>{name}</p>
                </div>
                {unit_descriptor && <p className={`text-port-text text-xs`}>{unit_descriptor}</p>}
                {definition &&
                    <p className="text-port-text text-[9px] line-clamp-5">{definition}</p>
                }
            </div>
        </div>
    );
};


export default MetricCard;
